import './dashboard';
import './widgets';

async function loadReportSearch() {
  if (document.getElementById('report-search')) {
    const { default: initReportSearch } = await import(
      /* webpackChunkName: "report-search" */ './report/search'
    );
    const { default: initCopyActions } = await import(
      /* webpackChunkName: "report-search" */ './report/search/copy-actions'
    );

    initReportSearch();
    initCopyActions();
  }
}

async function loadStaffListing() {
  if (document.getElementById('team-listing')) {
    const { default: initTeamListing } = await import(
      /* webpackChunkName: "team-listing" */ './team/listing'
    );

    initTeamListing();
  }
}

async function loadNewsListing() {
  if (document.getElementById('news-listing')) {
    const { default: initNewsListing } = await import(
      /* webpackChunkName: "news-listing" */ './news'
    );

    initNewsListing();
  }
}

export default async function loadPages() {
  await loadReportSearch();
  await loadStaffListing();
  await loadNewsListing();
}
